// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/handmuster/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const handmusterDE: PageEntry = {
  id: "post.handmuster",
  locale: "de",
  slug: "handmuster",
  seo: {
    title: "Glossar: Handmuster einfach erklärt | Dietz GmbH",
    description: "Handmuster bezieht sich auf ein manuell hergestelltes Muster oder Prototyp einer Feder, das von Hand gefertigt wurde, bevor die eigentliche Massenproduktion beginnt. Handmuster die",
  },
  type: "post",
  h1: "Glossar: Handmuster einfach erklärt",
  intro: "Handmuster bezieht sich auf ein manuell hergestelltes Muster oder Prototyp einer Feder, das von Hand gefertigt wurde, bevor die eigentliche Massenproduktion beginnt. Handmuster dienen dazu, das Design und die Funktionalität einer Feder zu überprüfen, bevor teure Werkzeuge und Maschinen eingesetzt werden. Ingenieure und Designer verwenden Handmuster, um sicherzustellen, dass die Feder den spezifizierten Anforderungen entspricht und eventuelle Anpassungen vor der Serienproduktion vorzunehmen. Die Erstellung von Handmustern ist eine wichtige Phase in der Entwicklung neuer Federdesigns.",
  blocks: [

  ],
};
